// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCNr3KwqvBxawbGRxLQepw9p_ateBY9ojU",
  authDomain: "ceertilbot-itqo.firebaseapp.com",
  projectId: "ceertilbot-itqo",
  storageBucket: "ceertilbot-itqo.firebasestorage.app",
  messagingSenderId: "550828779255",
  appId: "1:550828779255:web:bb51b6b17822877e1295f2",
  measurementId: "G-8EQ4YB7J3Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const logMyEvent = (eventName, params) => {
  logEvent(analytics, eventName, params);
};
const analytics = getAnalytics(app);
export default app;